<template>
  <d-button
    @click="handleClick"
    class="d-flex align-items-center justify-content-center"
    :theme="theme"
    :outline="outline"
    :size="size"
    :disabled="loading || done"
  >
    <template v-if="useSpinner && loading">
      <odd-spinner :size="spinnerSize" class="my-1"/>
    </template>
    <template v-else>
      {{ computedText }} <i class="material-icons ml-1">{{ computedIcon }}</i>
    </template>
  </d-button>
</template>

<script>
export default {
  data() {
    return {
      done: false
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    text: {
      type: String
    },
    loadingText: {
      type: String
    },
    doneText: {
      type: String
    },
    icon: {
      type: String
    },
    loadingIcon: {
      type: String
    },
    doneIcon: {
      type: String
    },
    theme: {
      type: String,
      default: "primary"
    },
    outline: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: null
    },
    useSpinner: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    loading(newValue, oldValue) {
      if (newValue === false) {
        this.done = true;
        setTimeout(() => {
          this.done = false;
        }, 3000);
      }
    }
  },
  computed: {
    computedText() {
      if (this.loading && !this.done) {
        return this.loadingText;
      } else if (this.done) {
        return this.doneText || this.text;
      } else {
        return this.text;
      }
    },
    computedIcon() {
      if (this.loading && !this.done) {
        return this.loadingIcon || this.icon;
      } else if (this.done) {
        return this.doneIcon || this.icon;
      } else {
        return this.icon;
      }
    },
    spinnerSize() {
       if (this.size === 'sm') {
        return 14
      } else if (this.size === null) {
        return 16
      } else {
        return 19
      }
    }
  },
  methods: {
    /**
     * Triggered when the button is clicked.
     *
     * @event click
     */
    handleClick(e) {
      this.$emit("click", e);
    }
  }
};
</script>

<style></style>
